<template>
    <div>
        <div :class="[ expandable ? 'panel--expand' : 'panel' ]">
            <div class="panel__header">
                <h2>
                    <i class="panel__header__icon icons icon-graduation"></i>
                    <span>{{$t('dashboard.files.title')}}</span>
                </h2>
            </div>

            <div class="panel__body" :class="{expanded}">
                <div v-if="!fileItems.length" class="panel--empty">
                    <center>{{$t('dashboard.files.no_skills')}}</center>
                </div>
                <table v-else class="panel__table">
                    <tbody>
                        <tr v-for="(item, index) in fileItems" :key="`file_${item.id}_${index}`">
                            <td>{{item.name}}</td>
                            <td>
                                <div class="actions">
                                    <b class="actions__action--view" @click="showDiplomasModal(item)">{{$t('dashboard.files.view')}}</b>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="expandable" class="panel__btn-expand" @click="togglePanelExpansion">
                <div v-if="expanded"><i class="icons icon-arrow-up"></i>{{$t('dashboard.files.see_less')}}</div>
                <div v-else><i class="icons icon-arrow-down"></i>{{$t('dashboard.files.see_all')}}</div>
            </div>

            <view-file-modal />
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import ViewFileModal from '@/components/modals/evaluations/ViewFileModal';

    @Component({})
    export default class FilesPanel extends Vue {
        name = 'files-panel';
        expanded = false;

        get fileItems() {
            return this.$store.state.profile.profile.files || [];
        }

        togglePanelExpansion() {
            this.expanded = !this.expanded;
        }

        get expandable() {
            return this.fileItems.length && this.fileItems.length > 4;
        }

        showDiplomasModal(file) {
            this.$modal.show('view-file-modal', { file });
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/panels/profile/FilesPanel.vue